module.exports = __webpack_public_path__ + "school/img/microCourseBg.55f21f98.jpg";